export default __webpack_public_path__ + "media/images/planning_day-eb1136cb885d8fe7068bb768aa85c331.svg";